
import { upperFirst, map } from 'lodash'

export const properCase = (str) => map(str.split(' '), upperFirst).join(' ')
